import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { posthog, isAnalyticsEnabled } from '../lib/analytics';

/**
 * Emits a PostHog `$pageview` event every time the route changes.
 *
 * Must be rendered inside the React Router tree (it uses `useLocation`).
 * No-op unless analytics is enabled via VITE_POSTHOG_KEY.
 */
export function useAnalyticsPageView(): void {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      pathname: location.pathname,
    });
  }, [location.pathname]);
}
